import request from '@/utils/request'


// 查询订单结算列表
export function listOrderSettlement(query) {
  return request({
    url: '/user/order-settlement/list',
    method: 'get',
    params: query
  })
}

// 查询订单结算分页
export function pageOrderSettlement(query) {
  return request({
    url: '/user/order-settlement/page',
    method: 'get',
    params: query
  })
}

// 查询订单结算详细
export function getOrderSettlement(data) {
  return request({
    url: '/user/order-settlement/detail',
    method: 'get',
    params: data
  })
}

// 新增订单结算
export function addOrderSettlement(data) {
  return request({
    url: '/user/order-settlement/add',
    method: 'post',
    data: data
  })
}

// 修改订单结算
export function updateOrderSettlement(data) {
  return request({
    url: '/user/order-settlement/edit',
    method: 'post',
    data: data
  })
}

// 删除订单结算
export function delOrderSettlement(data) {
  return request({
    url: '/user/order-settlement/delete',
    method: 'post',
    data: data
  })
}

// 生成订单结算（月结等，无请求体）
export function generateOrderSettlement() {
  return request({
    url: '/user/order-settlement/generate',
    method: 'post'
  })
}
